<ll-titulo>Generar Instrumento Nuevo</ll-titulo>

<instrumento-lote (instrumentoChange)="actualizarInstrumento($event)"></instrumento-lote>
